import { Link } from "react-router-dom";
import { TopBar } from "@/components/TopBar";

export const NotFound = () => (
  <div className="relative z-10">
    <TopBar />
    <main data-testid="match-not-found" className="max-w-7xl mx-auto px-4 sm:px-8 py-20">
      <h1 className="font-display text-5xl font-bold uppercase mb-6">Jogo não encontrado</h1>
      <Link to="/" data-testid="not-found-home" className="tap inline-flex h-12 px-6 items-center bg-[#CCFF00] text-black font-semibold">Voltar ao histórico</Link>
    </main>
  </div>
);
